<template>
  <div>
    <card title="Payouts" :subtitle="$store.getters.periodSelected ? $store.getters.periodSelected.label : ''">
      <div>
        <Payouts-Table/>
      </div>
      <div slot="corner">
        
      </div>
      <!-- <div slot="footer" class="stats">
       <i class="far fa-clock"/> This Month
      </div> -->
    </card>
  </div>
</template>

<script>
import {ObjectsWithId, Payout} from 'src/classes/datamodel.js'
export default {
  name: 'Payouts-Card',
  created () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'SET_PERIOD_SELECTED' || mutation.type === 'SET_COMPANY_SELECTED') {
        // we leave select mode if there's a change in the table data
        // timeout is because otherwise it happens during table rendering and messes up the columns 
        setTimeout(()=>this.selectMode = false, 0)
      }
    })
  },
  data () {
    return {
      selectMode: false // true when checkbox is checked
    }
  },
  methods: {
  },
  watch: {
    selectMode: function (val) {
      // We display / hide the checkboxes in the table
      if (val) {
        this.$store.commit('SELECT_OBJECTS')
      }
      else {
        if(this.$store.getters.selectedObjectsJson) {
          this.$store.commit('STOP_SELECT_OBJECTS')
        }
      }
    }
  },
  destroyed () {
    // we force a STOP_SELECT_OBJECTS in case user leaves the page after activating selectMode
    this.$store.commit('STOP_SELECT_OBJECTS')
  }
}
</script>

<style>

</style>